module.exports = __webpack_public_path__ + "static/media/create_collection.52ccdc46.svg";